<template lang='pug'>
.job-slide-out(:class='{ "has-job" : asset !== null }')
	asset-slide-out(
		:state='state'
		:asset='asset'
		:asset-key='assetKey'
		:asset-name='assetName'
		@close='$emit( "close" )'
		@edit='$emit( "edit" )'
		@delete='$emit( "delete" )'
	)

		.title-container(
			slot='title'
			v-if='asset'
		)
			h1.title Job # {{ asset.number }}
			.box
			h1.status {{ asset.status }}

		.title-container(
			v-else
			slot='title'
		)
			h1.title Job

		page.jobs-page.side-sheet-content(
			slot='side-sheet-content'
			:tabs='tabs'
		)

			.body-wrapper(slot='main-body')
				job(
					v-if='asset'
					:job='asset'
				)

				.loading-indicator.spacey(v-else) Loading
					span .
					span .
					span .

			.body(slot='tab-comments')
				comments(
					v-if='asset'
					:section-id='`jobs-${asset.jobsKey}`'
					:user='user'
					@replied-to-comment='email'
				)

			.body(slot='tab-materials' v-if='asset')
				job-materials(
					:asset='asset'
				)

			.body(slot='tab-engineering-action-requests' v-if='asset')
				engineering-requests(
					:requests='asset.actionRequests'
				)

			.body(slot='tab-documents' v-if='asset')
				document-list(
					:documents='asset.folder'
					:a-files='asset.file'
					:assetKey='asset.jobsKey'
					empty-message='No documents to show'
					@document-clicked='openDocument'
					@close='$emit( "close" )'
				)
</template>

<script>
import Job from '@/components/slide-outs/jobs/Job';
import JobMaterials from '@/components/slide-outs/jobs/JobMaterials';
import SideSheet from '@/components/SideSheet';
import Comments from '@/components/comments';
import Page from '@/components/Page';
import DropBox from '@/components/form-inputs/DropBox';
import EngineeringRequests from '@/components/slide-outs/jobs/EngineeringReq';
import AssetSlideOut from '@/components/slide-outs/AssetSlideOut';
import DocumentList from '@/components/DocumentList';

import { objectOrNull } from '@/lib/vue-validators';

import { SendEmail } from '@/lib/API';

export default {
	name : 'job-slide-out',

	props : {
		state : {
			type     : String,
			required : true,
		},

		asset : {
			required  : true,
			validator : objectOrNull,
		},

		assetKey : {
			required : true,
		},

		assetName : {
			required : true,
		},
	},

	data : () => ( {
		tabs : {
			'comments'                    : 'Comments',
			'materials'                   : 'Materials',
			'engineering-action-requests' : 'Engineering Action Requests',
			'documents'                   : 'Documents',
		},
	} ),

	computed : {

		user() {
			return this.$store.state.postgresUser;
		},

	},

	methods : {
		email( recipientKey, link ) {
			const { asset } = this;

			const sectionDescription = `Job #${asset.number}`;

			const emailData = {
				sectionDescription,
				link
			};

			SendEmail( this.user.usersKey, [recipientKey], 'reply', emailData );
		},

		openDocument( file ) {
			const { name } = file;

			this.$store.dispatch( 'openDocument', name );
		}
	},

	components : {
		Job,
		JobMaterials,
		SideSheet,
		Comments,
		Page,
		DropBox,
		EngineeringRequests,
		AssetSlideOut,
		DocumentList,
	}
};
</script>

<style lang='scss'>
.job-slide-out {

	&:not(.has-job) {

		.toggle,
		.main {
			opacity: 0;
		}
	}

	.document-list {
		padding: 30px;
	}

	.toggle {
		margin: 15px 30px!important;
	}

	.body-wrapper {
		width: 100%;

		.loading-indicator {
			text-align: center;
		}
	}

	.body {

		> p.spacey {
			text-align: center;
		}
	}

	// This is external styling of the Page Component
	.page {

		.main-body {
			display: flex;
			flex-flow: row nowrap;
			justify-content: flex-start;
			width: 100%;

			.body {
				padding: 0px 15px;
			}
		}

		.main {
			position: relative;

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 75px;
				z-index: 0;
				background: linear-gradient(180deg, #F3F6FA 0%, rgba(243, 246, 250, 0) 100%);
			}
		}
	}

	.side-sheet-content {

		.body {
			position: relative;
			overflow: hidden;
			padding-bottom: 250px;

			// External Styling of the Comments component
			.comment-section {
				background: white;

				.comment-count {
					padding: 15px 83px;

					p {
						font-size: 14px;
						font-weight: 300;
					}
				}

				.comment-thread-container {
					padding: 15px 83px;
				}

				.add-comment {

					.comment-wrapper {
						margin: 15px 83px;

						.input-container {

							input {
								font-size: 14px;

								&::placeholder {
									color: $input-color!important;
								}
							}
						}
					}
				}
			}

			// External Styling of EngineeringRequest
			.engineering-requests {

				h1 {
					text-align: center;
				}
			}
		}
	}
}

@media only screen and (max-width: 640px ) {

	.full-page.jobs-page .page {

		.body {

			.comment-section {

				.comment-count,
				.comment-thread-container {
					padding: 15px 30px;
				}

				.comment-wrapper {
					margin: 15px 30px;
				}
			}
		}

		.toggle-wrapper {

			.toggle {
				margin: 0 !important;

				.option {
					white-space: nowrap;
				}
			}
		}
	}
}
</style>
